export default __webpack_public_path__ + "static/faq-3cd324af33e89def6b4d3a7697cb2722.svg";